import React, { useReducer, useEffect} from "react";
import tareasXprocedimientoContext from "./tareasXprocedimientoContext.js";
import { getAllTareasXprocedimiento, addTareasXprocedimiento, updateTareasXprocedimiento, deleteTareasXprocedimiento } from "../../api/tareasXprocedimiento.js";
import tareasXprocedimientoReducer from "./tareasXprocedimientoReducer.js";
//Types
import { 
    ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO,
  } from "./tareasXprocedimientoActions.js";

const TareasXprocedimientoState = props =>{

    const initialState = {
        TareasXprocedimientoList: []
     };

    const [state, dispatch] = useReducer(tareasXprocedimientoReducer, initialState);

    const actualizarTareasXprocedimientoList = async () => {
        try{
            const resp = await getAllTareasXprocedimiento();
            
            const tareasXprocedimiento = resp.data.data;

            dispatch({
                type: ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO,
                payload: tareasXprocedimiento
            });
            
            return tareasXprocedimiento;
        }catch(err){
            console.log(err)
        }

    };

    const agregarTareasXprocedimiento = async (dato) => {

        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addTareasXprocedimiento
            console.log("TareasXprocedimiento en TareasXprocedimientoState");
            console.log(dato);
            const resp = await addTareasXprocedimiento(dato);
            const TareasXprocedimiento = resp.data.data;
            
            return TareasXprocedimiento;
            
        }catch(err){
            console.log(err);
            return null;
        }
        
    };

    const modificarTareasXprocedimiento = async (dato) => {
        try{
            const resp = await updateTareasXprocedimiento(dato);
            const tareasXprocedimiento = resp.data.data;
            return tareasXprocedimiento;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarTareasXprocedimiento = async (id) => {
        try{
            
            const resp = await deleteTareasXprocedimiento(id);
            const tareasXprocedimientoo = resp.data.data;
            
            return tareasXprocedimientoo;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {

        actualizarTareasXprocedimientoList();

    },[])

    return(
        <tareasXprocedimientoContext.Provider
            value={{
                tareasXprocedimientoList: state.tareasXprocedimientoList,
                actualizarTareasXprocedimientoList,
                agregarTareasXprocedimiento,
                modificarTareasXprocedimiento,
                eliminarTareasXprocedimiento
            }}
        >
            {props.children}
        </tareasXprocedimientoContext.Provider>
    )

}

export default TareasXprocedimientoState;